<template>
  <div class="MyOrder">
    <div class="add">
      <el-button type="primary" plain @click="handleToExtraStandard()">
        新增标外维修申请
      </el-button>
    </div>
    <ul class="tagList">
      <li
        :class="{ selected: form_head_uuid === item.form_head_uuid }"
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        @click="changeIndex(item.form_head_uuid)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="orderBox" v-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span>商品</span>
        <span>单价</span>
        <span>数量</span>
        <!-- <span>状态</span> -->
        <!-- <span>交易操作</span> -->
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <div class="orderHeader">
            <span class="orderTime">{{ item.u6g7gjunacqjmudx }}</span>
            <span class="orderId">
              {{ '维修单编号：' + item['3pp6dg9j4ex79ook'] }}
            </span>
            <!-- <span class="state">{{ tagList[item.state + 1] }}</span> -->
            <!-- <span class="deleteBtn" @click="deleteOrder(item.id)">
              <i class="iconfont icon-close" />
            </span> -->
          </div>
          <div
            class="orderDetail"
            v-for="(order, idx) in item.children"
            :key="idx"
          >
            <!-- <img
              :src="
                order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                  ? order.mnkt8dkjryhvdej3[0].url
                  : ''
              "
              alt="商品图片"
            /> -->
            <div class="goodsName">
              <p>
                {{ order.zk50hcofy4pvtckl }}
              </p>
              <!-- <span>{{ item.goods.spec }}</span> -->
            </div>
            <!-- <span class="unitPrice">{{ '￥' + order.rojkudmmvpzinpar }}</span> -->
            <!-- <span class="num">{{ order.mcuilzaudpe3shlc }}</span> -->
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/order.svg" alt="" />
    </p>
    <!-- <Popup title="商品评价" @popupClose="closePopup" v-show="popupShow">
      <div class="popupContent" slot="popupContent">
        <div class="scoreBox">
          <span class="tips">评分：</span>
          <i
            class="iconfont icon-collection_fill"
            v-for="(item, index) in 5"
            :key="'star' + index"
            :style="{ color: index + 1 <= curStar ? '#f9bd4f' : 'white' }"
            @mouseover="setCurStar(index + 1)"
            @mouseout="setCurStar(0)"
            @click="confirmStar(index + 1)"
          />
        </div>
        <textarea
          v-model="comment"
          cols="30"
          rows="10"
          placeholder="请输入评论内容"
        ></textarea>
        <button @click="sendComment">发表</button>
      </div>
    </Popup> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
// import {
//   getOrderByState,
//   deleteOrder,
//   confirmReceive,
//   pay,
//   sendComment,
// } from "../../api/client";
import Popup from "../../components/Popup";
import { online, children, execButton } from "@/api/platform";
import { otherSystemGetLoginToMeUrl } from "@/util/util";
export default {
  name: "MyOrder",
  components: {
    Popup,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        {
          name: "全部",
          form_head_uuid: "f0bcaa65a87f40f2af4623b3e5e54299",
        },
        { name: "审核中", form_head_uuid: "57bf9df042314749a434f57ac915ab8d" },
        {
          name: "审核成功",
          form_head_uuid: "663539e2fdb548e38d479752087bed4a",
        },
        {
          name: "审核失败",
          form_head_uuid: "eabde29c4e4c4db18e9901ebe3582819",
        },
        {
          name: "维修完成",
          form_head_uuid: "6c748341ef2643758ebd3039d1e01d0c",
        },
      ],
      form_head_uuid: "f0bcaa65a87f40f2af4623b3e5e54299",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
    };
  },

  methods: {
    // 获取订单列表
    async getOrderList () {
      const { form_head_uuid, page, limit } = this;
      const { meta, result } = await online({
        form_head_uuid,
        page,
        limit,
        keyword: "",
        select_option: "",
      });
      let list = await Promise.all(
        result.map(async (el) => ({
          ...el,
          children: await this.children(el.id),
        }))
      );
      this.orderList = list;
      this.total = meta.total;
    },
    // 获取子表数据
    async children (record_id) {
      const { form_head_uuid } = this;
      const { result } = await children({
        page: 1,
        limit: 100,
        field_uuid: "60852bd2d53d11eeb76c0242321230b4",
        form_head_uuid,
        record_id,
      });
      return result;
    },
    // 切换页数
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    navTo (route) {
      this.$router.push(route);
    },
    handleToExtraStandard () {
      otherSystemGetLoginToMeUrl('c31f3136e59411ee97280242ac150003', 'GC7HrA6JngQXnJjW')

    },
  },

  mounted () {
    this.getOrderList();
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.MyOrder {
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .orderBox {
    width: 100%;
    margin-top: 20px;
    .orderTableHeader {
      width: 100%;
      height: 40px;
      background-color: #f5f5f5;
      border: 1px solid @borderColor;
      color: @fontDefaultColor;
      font-size: 14px;
      line-height: 40px;
      display: flex;
      justify-content: flex-start;
      span {
        display: inline-block;
        width: 150px;
        line-height: 40px;
        text-align: center;
        &:first-child {
          width: 500px;
        }
      }
    }
    .orderList {
      width: 100%;
      li {
        border: 1px solid @borderColor;
        font-size: 13px;
        margin-top: 10px;
        .orderHeader {
          background-color: #f1f1f1;
          height: 40px;
          line-height: 40px;
          padding: 0 5px;
          .orderTime {
            font-weight: 600;
          }
          .orderId,
          .state {
            margin-left: 10px;
          }
          .deleteBtn {
            float: right;
            cursor: pointer;
            i {
            }
          }
        }
        .orderDetail {
          width: 100%;
          padding: 10px;
          position: relative;
          overflow: hidden;
          display: flex;
          justify-content: flex-start;
          img {
            width: 84px;
            height: 84px;
            display: inline-block;
          }
          .goodsName {
            display: inline-block;
            margin-left: 5px;
            width: 400px;
            vertical-align: top;
            p {
              cursor: pointer;
              line-height: 20px;
              &:hover {
                text-decoration: underline;
              }
            }
            span {
              color: @fontDefaultColor;
              display: block;
              margin-top: 10px;
            }
          }
          .unitPrice,
          .num,
          .amount,
          .hasComment {
            display: inline-block;
            vertical-align: top;
            width: 150px;
            height: 85px;
            line-height: 85px;
            text-align: center;
          }
          .status {
            position: absolute;
            right: 10px;
            img {
              width: 70px;
              opacity: 0.9;
            }
          }
          button {
            position: absolute;
            right: 90px;
            bottom: 40px;
            width: 70px;
            height: 30px;
            border-radius: 3px;
            background-color: @thirdColor;
            color: white;
            border: none;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0;
    }
  }
  .popupContent {
    padding: 10px;
    .scoreBox {
      width: 100%;
      height: 50px;
      position: relative;
      line-height: 50px;
      text-align: left;
      .tips {
        font-size: 15px;
        vertical-align: middle;
        display: inline-block;
      }
      i {
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        margin-right: 5px;
        -webkit-text-stroke: 1px #f9bd4f;
      }
    }
    textarea {
      width: 400px;
      height: 80px;
      padding: 5px;
      border: 1px solid @borderColor;
      display: block;
      margin-top: 10px;
    }
    button {
      display: block;
      margin: 10px auto;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      background-color: #313541;
      color: white;
      border: none;
    }
  }
}
.emptyTips {
  text-align: center;
  margin: 200px auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/ExtraStandard.vue